import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  all,
  put,
  takeLatest,
  call,
  select
} from "redux-saga/effects";
import {
  listProducts, listProductsFailed, listProductsSuccess,
  listSurveyByMember, listSurveyByMemberSuccess, listSurveyByMemberFailed,
  pointHistoryByMember, pointHistoryByMemberSuccess, pointHistoryByMemberFailed,
  listNotificationByMember, listNotificationByMemberFailed, listNotificationByMemberSuccess,
  listExchanceHistorySuccess, listExchanceHistoryFailed, listExchanceHistory,
  finishPointExchanged, finishPointExchangedSuccess, finishPointExchangedFailed,
  finishPointDonated, finishPointDonatedSuccess, finishPointDonatedFailed,
  createInquiry, createInquiryFailed, createInquirySuccess,
  listReports, listReportsSuccess, listReportsFailed,
  sendMfaSms, sendMfaSmsSuccess, sendMfaSmsFailed,
  sendMfaMail, sendMfaMailSuccess, sendMfaMailFailed,
  verifyMfaMail, verifyMfaMailSuccess, verifyMfaMailFailed,
  verifyMfaSms, verifyMfaSmsSuccess, verifyMfaSmsFailed,
  selectExchanged, selectMfaRoutingState, clearMfaRoutingState,
} from "./redux";
import { selectUserProfileEdit, updateUserProfile } from "../auth/redux"; 
import httpServices from '../../core/http/apis'
import { toastify } from "../../helper/toast";
import { push, replace } from "connected-react-router";
import paths from "../../helper/pathRoutes";
import { isEmpty } from "lodash";
import axios from "axios";
import storage from "../../helper/storage";

// --- 既存のSaga（listProducts 〜 watchListReports）はそのまま維持 ---

function* listProductsSaga(action) {
  const page = action.payload
  try {
    yield put(showLoading());
    const resps = yield call(listProductsReq, page)
    yield put({ type: listProductsSuccess, payload: resps.data });
  } catch (error) {
    yield put({ type: listProductsFailed });
  } finally {
    yield put(hideLoading());
  }
}
const listProductsReq = async (page) => {
  const res = await httpServices.get(`/api/products/get`, { page: page })
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchListProducts() {
  yield takeLatest(listProducts.toString(), listProductsSaga);
}

function* listSurveyByMemberSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(listSurveyByMemberReq, action.payload)
    yield put({ type: listSurveyByMemberSuccess, payload: resps });
  } catch (error) {
    yield put({ type: listSurveyByMemberFailed });
  } finally {
    yield put(hideLoading());
  }
}
const listSurveyByMemberReq = async (payload) => {
  const res = await httpServices.get(`/api/member/surveys`, payload)
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchListSurveyByMember() {
  yield takeLatest(listSurveyByMember.toString(), listSurveyByMemberSaga);
}

function* pointHistoryByMemberSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(pointHistoryByMemberReq, action.payload)
    yield put({ type: pointHistoryByMemberSuccess, payload: resps.data });
  } catch (error) {
    yield put({ type: pointHistoryByMemberFailed });
  } finally {
    yield put(hideLoading());
  }
}
const pointHistoryByMemberReq = async (page) => {
  const res = await httpServices.get(`/api/member/point-histories`, { page: page })
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchPointHistoryByMember() {
  yield takeLatest(pointHistoryByMember.toString(), pointHistoryByMemberSaga);
}

function* listNotificationByMemberSaga() {
  try {
    yield put(showLoading());
    const resps = yield call(listNotificationByMemberReq)
    yield put({ type: listNotificationByMemberSuccess, payload: resps.data });
  } catch (error) {
    yield put({ type: listNotificationByMemberFailed });
  } finally {
    yield put(hideLoading());
  }
}
const listNotificationByMemberReq = async () => {
  const res = await httpServices.get(`/api/notifications`)
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchListNotificationByMember() {
  yield takeLatest(listNotificationByMember.toString(), listNotificationByMemberSaga);
}

function* listExchanceHistorySaga() {
  try {
    yield put(showLoading());
    const resps = yield call(listExchanceHistoryReq)
    yield put({ type: listExchanceHistorySuccess, payload: resps.data });
  } catch (error) {
    yield put({ type: listExchanceHistoryFailed });
  } finally {
    yield put(hideLoading());
  }
}
const listExchanceHistoryReq = async () => {
  const res = await httpServices.get(`/api/member/exchange_history`)
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchListExchanceHistory() {
  yield takeLatest(listExchanceHistory.toString(), listExchanceHistorySaga);
}

function* finishPointExchangedSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(finishPointExchangedReq, action.payload)
    if (!resps.result) {
      toastify({ type: 'error', msg: resps?.message })
      yield put({ type: finishPointExchangedFailed });
      return
    }
    yield put({ type: finishPointExchangedSuccess, payload: resps });
    yield put(replace(paths.exchangeComplete))
  } catch (error) {
    yield put({ type: finishPointExchangedFailed });
  } finally {
    yield put(hideLoading());
  }
}
const finishPointExchangedReq = async (payload) => {
  const res = await httpServices.post(`/api/exchange`, payload)
  if (!res || !res.data) {
    toastify({ type: 'error', msg: 'もう一度入力してください。' })
    throw new Error("Opps");
  }
  return res.data;
}
function* watchFinishPointExchanged() {
  yield takeLatest(finishPointExchanged.toString(), finishPointExchangedSaga);
}

function* finishPointDonatedSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(finishPointDonatedReq, action.payload)
    if (!resps.result) {
      toastify({ type: 'error', msg: resps?.message })
      yield put({ type: finishPointDonatedFailed });
      return
    }
    yield put({ type: finishPointDonatedSuccess, payload: resps });
    yield put(push(paths.donateComplete))
  } catch (error) {
    yield put({ type: finishPointDonatedFailed });
  } finally {
    yield put(hideLoading());
  }
}
const finishPointDonatedReq = async (payload) => {
  const res = await httpServices.post(`/api/donate`, payload)
  if (!res || !res.data) {
    toastify({ type: 'error', msg: 'もう一度入力してください。' })
    throw new Error("Opps");
  }
  return res.data;
}
function* watchFinishPointDonated() {
  yield takeLatest(finishPointDonated.toString(), finishPointDonatedSaga);
}

function* createInquirySaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(createInquiryReq, action.payload?.payload)
    yield put({ type: createInquirySuccess, payload: resps });
    if (action.payload?.onSuccess) {
      yield call(action?.payload?.onSuccess());
    }
  } catch (error) {
    yield put({ type: createInquiryFailed });
  } finally {
    yield put(hideLoading());
  }
}
const createInquiryReq = async (payload) => {
  const auth = localStorage.getItem('persist:root') ? JSON.parse(localStorage.getItem('persist:root'))?.auth : null;
  const prm = auth ? JSON.parse(auth).prmDecoded : null;
  payload.prm = prm;
  const res = await httpServices.post(`/api/inquiries/create`, payload)
  if (!res || !res.data) {
    toastify({ type: 'error', msg: 'もう一度入力してください。' })
    throw new Error("Opps");
  }
  return res.data;
}
function* watchCreateInquiry() {
  yield takeLatest(createInquiry.toString(), createInquirySaga);
}

function* listReportsSaga() {
  try {
    yield put(showLoading());
    const resps = yield call(listReportsReq)
    yield put({ type: listReportsSuccess, payload: resps });
  } catch (error) {
    yield put({ type: listReportsFailed });
  } finally {
    yield put(hideLoading());
  }
}
const listReportsReq = async () => {
  const res = await httpServices.get(`/api/reports`)
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
}
function* watchListReports() {
  yield takeLatest(listReports.toString(), listReportsSaga);
}

function* sendMfaSmsSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(sendMfaSmsReq, {});

    if (!resps || !resps?.result) {
      const errMsg = resps?.message || 'SMS認証コードの送信に失敗しました。';
      yield put({ type: sendMfaSmsFailed, payload: errMsg });
      toastify({ type: 'error', msg: errMsg });
      if (action.payload.setSubmitting) action.payload.setSubmitting(false);
      return;
    }
    yield put({ type: sendMfaSmsSuccess, payload: resps });
    yield put(push({
        pathname: paths.mfaSms,
        state: { authType: action.payload.authType }
    }));
  } catch (error) {
    const serverErrMsg = error?.response?.data?.message || 'SMS認証コードの送信に失敗しました。';
    yield put({ type: sendMfaSmsFailed, payload: serverErrMsg });
    toastify({ type: 'error', msg: serverErrMsg });
    if (action.payload.setSubmitting) action.payload.setSubmitting(false);
  } finally {
    yield put(hideLoading());
  }
}
const sendMfaSmsReq = async (payload) => {
  const res = await httpServices.post(`/api/member/mfa/send-sms`, payload);
  if (!res || !res.data) {
    toastify({ type: 'error', msg: 'もう一度やり直してください。' });
    throw new Error("Opps");
  }
  return res.data;
}
function* watchSendMfaSms() {
  yield takeLatest(sendMfaSms.toString(), sendMfaSmsSaga);
}

function* sendMfaMailSaga(action) {
  try {
    yield put(showLoading());
    const resps = yield call(sendMfaMailReq, {});

    if (!resps || !resps.result) {
      const errMsg = resps?.message || 'メール認証コードの送信に失敗しました。';
      yield put({ type: sendMfaMailFailed, payload: errMsg });
      toastify({ type: 'error', msg: errMsg });
      if (action.payload?.setSubmitting) action.payload.setSubmitting(false);
      return;
    }
    yield put({ type: sendMfaMailSuccess, payload: resps });
    yield put(push({ pathname: paths.mfaMail, state: { authType: action.payload?.authType } })); 
  } catch (error) {
    console.error("MFA送信Sagaキャッチ: ", error);
    const serverErrMsg = error?.response?.data?.message || 'メール認証コードの送信に失敗しました。';
    yield put({ type: sendMfaMailFailed, payload: serverErrMsg });
    toastify({ type: 'error', msg: serverErrMsg });
    if (action.payload?.setSubmitting) action.payload.setSubmitting(false);
  } finally {
    yield put(hideLoading());
  }
}
const sendMfaMailReq = async (payload) => {
  return (await httpServices.post(`/api/member/mfa/send-mail`, {})).data;
}
function* watchSendMfaMail() {
  yield takeLatest(sendMfaMail.toString(), sendMfaMailSaga);
}

// ==========================================
// 修正：メール認証コード検証 Saga（オブジェクト型指示書対応版）
// ==========================================
export function* verifyMfaMailSaga(action) {
  try {
    yield put(showLoading());
    const inputCode = action.payload?.mailCode || '';
    const resps = yield call(verifyMfaMailReq, { code: inputCode });
    
    if (!resps || !resps?.result) {
      // 【仕様1-2】有効期限切れ（10分経過）フラグが true の場合
      if (resps?.isExpired) {
        // 画面にエラーを出さず、即座に「認証方式選択画面（SCR-MFA-01）」へ強制遷移
        yield put(push(paths.mfa));
        return; // finallyブロックへ流れ、自動的にhideLoadingが走ります
      }

      // 【仕様1-3】通常の不一致エラーの場合
      const errMsg = resps?.message || '認証に失敗しました。';
      yield put({ type: verifyMfaMailFailed, payload: errMsg });
      if (action.payload.setSubmitting) action.payload.setSubmitting(false);
      return; // finallyブロックへ流れ、自動的にhideLoadingが走ります
    }

    yield put({ type: verifyMfaMailSuccess, payload: resps });

    const mfaRoutingState = yield select(selectMfaRoutingState); 
    const fromPage = action.payload?.from; 

    if (mfaRoutingState) {
      yield put({ type: clearMfaRoutingState.toString() });
    }

    const isProfileSaveRoute = mfaRoutingState?.pathname === paths.editProfileVerify && mfaRoutingState?.mode === 'save';
    const isProfileSubmitRoute = mfaRoutingState?.mode === 'submit';
    const isDonateRoute = mfaRoutingState?.pathname === paths.donateVerify;
    const isExchangeRoute = mfaRoutingState?.pathname === paths.exchangeVerify || mfaRoutingState?.state?.from === 'mfa_success';

    if (isDonateRoute) {
      // パターン0：ポイント寄付ルート
      const pointExchanged = yield select(selectExchanged);
      if (pointExchanged) {
        const { detailProductExchange, selectedAddressShipping, totalPointExchange } = pointExchanged;
        const payload = {
          address_id: selectedAddressShipping?.id || '',
          product_id: detailProductExchange?.id || '',
          points: totalPointExchange || (detailProductExchange?.points || 0)
        };
        yield put({ type: finishPointDonated.toString(), payload: payload });
      } else {
        yield put(push(paths.donateVerify));
      }
    } else if (isExchangeRoute) {
      // パターン1：ポイント交換ルート
      const pointExchanged = yield select(selectExchanged);
      if (pointExchanged) {
        const { detailProductExchange, selectedAddressShipping, totalPointExchange } = pointExchanged;
        const payload = {
          address_id: selectedAddressShipping?.id || '',
          product_id: detailProductExchange?.id || '',
          points: totalPointExchange || (detailProductExchange?.points || 0)
        };
        yield put({ type: finishPointExchanged.toString(), payload: payload });
      } else {
        yield put(push(paths.exchangeVerify));
      }
    } else if (isProfileSaveRoute) {
      // パターン2：確認画面の保存ボタンルート
      const userInfoEdit = yield select(selectUserProfileEdit);
      yield put(updateUserProfile({ ...userInfoEdit, mode: undefined }));
    } else if (isProfileSubmitRoute || mfaRoutingState === paths.editProfileVerify) {
      // パターン3：通常移動ルート（進む・戻る）
      const destination = mfaRoutingState?.pathname || paths.editProfileVerify;
      yield put(push(destination));
    } else if (mfaRoutingState && typeof mfaRoutingState === 'object' && mfaRoutingState.pathname) {
      yield put(push(mfaRoutingState.pathname));
    } else if (mfaRoutingState && typeof mfaRoutingState === 'string') {
      yield put(push(mfaRoutingState));
    } else if (fromPage === 'profile') {
      yield put(push(paths.userProfile));
    } else {
      yield put(push(paths.userProfile));
    }

  } catch (error) {
    // 固定エラーメッセージをメール専用の仕様書文言に最適化
    const serverErrMsg = error?.response?.data?.message || 'メール認証コードの送信に失敗しました。';
    yield put({ type: verifyMfaMailFailed, payload: serverErrMsg });
    if (action.payload.setSubmitting) action.payload.setSubmitting(false);
  } finally {
    yield put(hideLoading());
  }
}

const verifyMfaMailReq = async (payload) => {
  return (await httpServices.post(`/api/member/mfa/verify-mail`, payload)).data;
}
function* watchVerifyMfaMail() {
  yield takeLatest(verifyMfaMail.toString(), verifyMfaMailSaga);
}

// ==========================================
// 修正：SMS認証コード検証 Saga（オブジェクト型指示書対応版）
// ==========================================
export function* verifyMfaSmsSaga(action) {
  try {
    yield put(showLoading());
    const inputCode = action.payload?.smsCode || action.payload?.code || '';
    const resps = yield call(verifyMfaSmsReq, { code: inputCode });    

    // 修正：!resps.result だけでなく、構造体の不整合を防ぐため共通化
    if (!resps || !resps.result) {
      // 【仕様1-2】有効期限切れ（10分経過）フラグが true の場合
      if (resps?.isExpired) {
        // 画面にエラーを出さず、即座に「認証方式選択画面（SCR-MFA-01）」へ強制遷移
        yield put(push(paths.mfa));
        return; // finallyブロックへ流れ、自動的にhideLoadingが走ります
      }

      // 【仕様1-3】通常の不一致エラーの場合
      const errMsg = resps?.message || '認証に失敗しました。';
      yield put({ type: verifyMfaSmsFailed, payload: errMsg });
      if (action.payload.setSubmitting) action.payload.setSubmitting(false);
      return; // finallyブロックへ流れ、自動的にhideLoadingが走ります
    }

    yield put({ type: verifyMfaSmsSuccess, payload: resps });

    const mfaRoutingState = yield select(selectMfaRoutingState); 
    const fromPage = action.payload?.from; 

    if (mfaRoutingState) {
      yield put({ type: clearMfaRoutingState.toString() });
    }

    const isProfileSaveRoute = mfaRoutingState?.pathname === paths.editProfileVerify && mfaRoutingState?.mode === 'save';
    const isProfileSubmitRoute = mfaRoutingState?.mode === 'submit';
    const isDonateRoute = mfaRoutingState?.pathname === paths.donateVerify;
    const isExchangeRoute = mfaRoutingState?.pathname === paths.exchangeVerify || mfaRoutingState?.state?.from === 'mfa_success';

    if (isDonateRoute) {
      // パターン0：ポイント寄付ルート
      const pointExchanged = yield select(selectExchanged);
      if (pointExchanged) {
        const { detailProductExchange, selectedAddressShipping, totalPointExchange } = pointExchanged;
        const payload = {
          address_id: selectedAddressShipping?.id || '',
          product_id: detailProductExchange?.id || '',
          points: totalPointExchange || (detailProductExchange?.points || 0)
        };
        yield put({ type: finishPointDonated.toString(), payload: payload });
      } else {
        yield put(push(paths.donateVerify));
      }
    } else if (isExchangeRoute) {
      // パターン1：ポイント交換ルート
      const pointExchanged = yield select(selectExchanged);
      if (pointExchanged) {
        const { detailProductExchange, selectedAddressShipping, totalPointExchange } = pointExchanged;
        const payload = {
          address_id: selectedAddressShipping?.id || '',
          product_id: detailProductExchange?.id || '',
          points: totalPointExchange || (detailProductExchange?.points || 0)
        };
        yield put({ type: finishPointExchanged.toString(), payload: payload });
      } else {
        yield put(push(paths.exchangeVerify));
      }
    } else if (isProfileSaveRoute) {
      // パターン2：確認画面の保存ボタンルート
      const userInfoEdit = yield select(selectUserProfileEdit);
      yield put(updateUserProfile({ ...userInfoEdit, mode: undefined }));
    } else if (isProfileSubmitRoute || mfaRoutingState === paths.editProfileVerify) {
      // パターン3：通常移動ルート（進む・戻る）
      const destination = mfaRoutingState?.pathname || paths.editProfileVerify;
      yield put(push(destination));
    } else if (mfaRoutingState && typeof mfaRoutingState === 'object' && mfaRoutingState.pathname) {
      yield put(push(mfaRoutingState.pathname));
    } else if (mfaRoutingState && typeof mfaRoutingState === 'string') {
      yield put(push(mfaRoutingState));
    } else if (fromPage === 'profile') {
      yield put(push(paths.userProfile));
    } else {
      yield put(push(paths.userProfile));
    }

  } catch (error) {
    const serverErrMsg = error?.response?.data?.message || 'SMS認証コードの送信に失敗しました。';
    yield put({ type: verifyMfaSmsFailed, payload: serverErrMsg });
    if (action.payload.setSubmitting) action.payload.setSubmitting(false);
  } finally {
    yield put(hideLoading());
  }
}

const verifyMfaSmsReq = async (payload) => {
  return (await httpServices.post(`/api/member/mfa/verify-sms`, payload)).data;
}
function* watchVerifyMfaSms() {
  yield takeLatest(verifyMfaSms.toString(), verifyMfaSmsSaga);
}

export default function* myPointSaga() {
  yield all([
    watchListProducts(),
    watchListSurveyByMember(),
    watchPointHistoryByMember(),
    watchListNotificationByMember(),
    watchListExchanceHistory(),
    watchFinishPointExchanged(),
    watchFinishPointDonated(),
    watchCreateInquiry(),
    watchListReports(),
    watchSendMfaSms(),
    watchSendMfaMail(),
    watchVerifyMfaMail(),
    watchVerifyMfaSms(),
  ]);
}